import { render, staticRenderFns } from "./Exci.vue?vue&type=template&id=c74df482"
import script from "./Exci.vue?vue&type=script&lang=js"
export * from "./Exci.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports